boundLength